const ADMIN_MODE_KEY = 'adminMode'

export function isAdminMode(): boolean {
  if (typeof window === 'undefined') return false
  return sessionStorage.getItem(ADMIN_MODE_KEY) === 'true'
}

export function setAdminMode(active: boolean): void {
  if (typeof window === 'undefined') return
  if (active) {
    sessionStorage.setItem(ADMIN_MODE_KEY, 'true')
  } else {
    sessionStorage.removeItem(ADMIN_MODE_KEY)
  }
}
